import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import {
  CLEAN_OPTIONS,
  FETCH_OPTIONS,
  FETCH_OPTIONS_FAILURE,
  FETCH_OPTIONS_SUCCESS,
  SAVE_OPTIONS,
  SAVE_OPTIONS_FAILURE,
  SAVE_OPTIONS_SUCCESS,
} from '@Pages/RetroSynthesis/ProjectParametersDialog/constants';
import { noCache } from '@Utils/Network';
import {
  isNewSynthesisPlannerEnabled,
  isIktosPredictiveRetrosynthesisEnabled,
  isPaiPredictiveRetrosynthesisEnabled,
} from '@Pages/RetroSynthesis/predictiveUtils';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfRsProjectParametersDialog } from '@Containers/Dialogs/DialogsMapperConstants';
import { ProjectSynthesisPartner } from '../constants';

export const predictedOptionsList = [
  'RX2_PREDICTION_PLAN_SHOW_FULL_STEPS',
  'RX2_PREDICTION_PLAN_DEPTH',
  'RX2_PREDICTION_PLAN_STEPS',
  'RX2_PREDICTION_PLAN_BLOCKS',
  'RX2_PREDICTION_PLAN_PROCESSING_TIME',
  'RX2_PREDICTION_PLAN_LIBRARIES',
];
export const fetchAutoplanOptionsAction = () => async (dispatch) => {
  dispatch({ type: FETCH_OPTIONS });
  try {
    const result = await MessageBroker.send(RequestUrls.retroSynthesisAvailableOptions, {}, noCache());
    let response;
    let vendorsInfo = null;

    if (isNewSynthesisPlannerEnabled() && (isPaiPredictiveRetrosynthesisEnabled() || isIktosPredictiveRetrosynthesisEnabled())) {
      const partners = isIktosPredictiveRetrosynthesisEnabled() ? ProjectSynthesisPartner.IKTOS : ProjectSynthesisPartner.PAI;
      vendorsInfo = await MessageBroker.send(RequestUrls.vendorsInfo, { partners });
      response = result;
    } else {
      response = result.filter((option) => !predictedOptionsList.includes(option.name));
    }

    dispatch({
      type: FETCH_OPTIONS_SUCCESS,
      payload: { response, vendorsInfo },
    });
  } catch (e) {
    dispatch({
      type: FETCH_OPTIONS_FAILURE,
      payload: e,
    });
  }
};

export const saveAutoplanOptionsAction = (params) => async (dispatch) => {
  dispatch({ type: SAVE_OPTIONS });
  try {
    const result = await MessageBroker.send(RequestUrls.changePreferences, params);
    dispatch({
      type: SAVE_OPTIONS_SUCCESS,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: SAVE_OPTIONS_FAILURE,
      payload: e,
    });
  }
};

export const cleanOptionsAction = () => ({ type: CLEAN_OPTIONS });

export const openProjectParametersDialog = ({ rxn, databaseId, structure, file }) =>
  updateDialog({
    id: typeOfRsProjectParametersDialog,
    typeOfRsProjectParametersDialog,
    dialogType: typeOfRsProjectParametersDialog,
    rxn,
    databaseId,
    structure,
    file,
  });
